//
//
//
//
//
//
//
//
import { DateMixin } from '@/mixins/DateMixin';
export default {
  name: 'monthSelect',
  mixins: [DateMixin],
  props: {
    top: {
      type: String,
      default: '25px'
    },
    left: {
      type: String,
      default: '130px'
    }
  },
  mounted: function mounted() {
    this.$emit('change', this.monthFormatFun(this.monthTime));
  },
  methods: {
    // 月份变化
    onMonthChange: function onMonthChange(date, dateString) {
      this.monthTime = date;
      this.$emit('change', this.monthFormatFun(this.monthTime));
    }
  }
};